import { render, staticRenderFns } from "./wheel1.vue?vue&type=template&id=aca2ed48&"
import script from "./wheel1.vue?vue&type=script&lang=js&"
export * from "./wheel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports